import React, { useEffect, useState } from 'react';
import { useCompanyEditLogoModal } from './CompanyEditLogoModal';
import EditIcon from '@icons/EditIcon';
import CardCompanyAvatar from '@atoms/CardCompanyAvatar';
import useViewer from '@hooks/useViewer';

// Avatar and edit icon - used on dashboad and edit profile
// uses whole viewer query to save adding another request
const CompanyEditLogo = () => {
    const [logoUrl, setLogoUrl] = useState();
    const { viewer } = useViewer();
    const { openModal } = useCompanyEditLogoModal();

    useEffect(() => {
        if (!viewer || logoUrl) {
            return;
        }

        setLogoUrl(viewer.company.logoUrl);
    }, [viewer, logoUrl]);

    if (!viewer) {
        return null;
    }

    const { company } = viewer;

    const openEditLogoModal = async () => {
        const response = await openModal({ currentImageSrc: logoUrl });
        if (response.logoUrl) {
            setLogoUrl(response.logoUrl);
        }
    };

    return (
        <div className="d-flex">
            <a
                className="cursor-pointer relative"
                role="button"
                tabIndex={0}
                onClick={() => openEditLogoModal()}
                onKeyDown={e => {
                    if (e.keyCode === 13) {
                        openEditLogoModal();
                    }
                }}
            >
                <div style={{ position: 'absolute', right: '-16px', top: '-8px' }}>
                    <EditIcon />
                </div>

                <CardCompanyAvatar name={company.name} photoURL={logoUrl} sizeMobile={180} sizeDesktop={180} />
            </a>
        </div>
    );
};

export default CompanyEditLogo;
